import { convertObjectKeysToCamelCase, convertObjectKeysToSnakeCase } from '../utils';

//TODO: this should follow the create pattern used everywhere else
const carrierEntryResponseToCarrierEntryObject = (response) => {
    return {
        carrier: response.carrier,
        shipmentProvider: response.shipmentProvider,
        ratingProvider: response.ratingProvider,
        canadaPostAccountType: response.canadaPostAccountType,
        createdAt: response.created_at,
        enabled: response.enabled,
        id: response.id,
        params: convertObjectKeysToCamelCase(response.params),
    };
};

const carrierEntryObjectToCarrierEntryRequest = (object) => {
    return {
        carrier: object.carrier,
        shipmentProvider: object.shipmentProvider,
        ratingProvider: object.ratingProvider,
        canadaPostAccountType: object.canadaPostAccountType,
        enabled: object.enabled,
        id: object.id,
        params: convertObjectKeysToSnakeCase(object.params),
    };
};

export { carrierEntryObjectToCarrierEntryRequest, carrierEntryResponseToCarrierEntryObject };
